import React from 'react';
import IndicadorCargaGlobalCV from './controladorVista/indicadorCargaGlobalCV';

const IndicadorCargaGlobal: React.FunctionComponent = () => <IndicadorCargaGlobalCV />;

export default IndicadorCargaGlobal;
